import kapi from "./kratos";

const getCurrentUserLocal = () => {
    let user = localStorage.getItem('user')
    return user && JSON.parse(user);
}

const redirectToMfa = () => {
    const path = window.location.pathname
    const params = new URLSearchParams(window.location.search)
    if (path === "/logout" || path === "/settings-flow-handler") {
        return
    }
    if (path === "/login" && params.get("flow")) {
        return
    }

    let loginUrl = process.env.REACT_APP_API_URL + "/auth/self-service/login/browser?aal=aal2"
    if (path !== "/login") {
        const returnTo = window.location.origin + window.location.pathname + window.location.search
        loginUrl += "&return_to=" + encodeURIComponent(returnTo)
    }
    window.location.assign(loginUrl)
}

const hasSession = async () => {
    try {
        const response = await kapi.check_session();
        if (response.data.active) {
            const aal = response.data.authenticator_assurance_level
            const hasTotp = !!response.data.identity?.credentials?.totp
            // Optional 2FA: aal2 has completed MFA. aal1 with TOTP still needs the login challenge.
            if (aal !== "aal2" && hasTotp) {
                redirectToMfa()
                return "mfa"
            }

            let user = {
                "fullName": response.data.identity.traits.name.first + " " + response.data.identity.traits.name.last,
                "email": response.data.identity.traits.email
            }
            localStorage.setItem("user", JSON.stringify(user));
            return true;
        }
        else {
            localStorage.removeItem("user");
        }
    }
    catch (err) {
        if (err?.response?.data?.error?.id === "session_aal2_required") {
            redirectToMfa()
            return "mfa"
        }
        localStorage.removeItem("user");
    }
    return false;
}


const isAuthenticated = () => {
    // check for token
    const user = getCurrentUserLocal();

    if (user && user.email) {
        return true;
    } else {
        return false;
    }
}

const protectedNavigate = (url, fallbackUrl) => {
    const session = hasSession();
    session.then((session) => {
        if (session === "mfa") {
            return
        }
        if (session) {
            window.location.assign(url);
        }
        else {
            window.location.assign(fallbackUrl);
        }
    })
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getCurrentUserLocal,
    hasSession,
    isAuthenticated,
    protectedNavigate
};
